export default {
  background_image: 'Imagine de fundal',
};
